import { Link } from "react-router-dom";
import { CREDIBILITY, PRACTICES, SAMPLE_BRIEFINGS } from "../data/marketing";

const platformLinks = [
  ["Technology overview", "/technology"],
  ["EPR Control Portal concept", "/technology#epr"],
  ["Request SaaS walkthrough", "/technology#walkthrough"],
  ["Client login", "/portal/login", "footer-client-login-link"],
  ["Consultant login", "/admin", "footer-admin-login-link"],
];

const insightLinks = [
  ["Insights library", "/insights"],
  ["India EPR streams", "/insights/india-epr-eight-streams-2026"],
  ["PPWR for exporters", "/insights/ppwr-producer-status-indian-exporters"],
  ["EPR credits diligence", "/insights/epr-credits-india-buying-guide"],
  ...SAMPLE_BRIEFINGS.map((a) => [`${a.category} briefing (Draft)`, `/insights/${a.slug}`]),
];

function FooterColumn({ title, items }) {
  return (
    <div>
      <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-300">{title}</h3>
      <ul className="mt-5 space-y-3">
        {items.map(([label, href, testid]) => (
          <li key={`${label}-${href}`}>
            <Link to={href} className="text-sm text-emerald-100/60 transition-colors hover:text-emerald-300" data-testid={testid || `footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function TrustFooter() {
  return (
    <footer className="noise-overlay relative bg-forest-deep text-[#FBF9F4]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr_1fr_1.1fr]">
          <div>
            <img src="/logo-clymaco.webp" alt="CLYMACO Sustainability Services" className="h-20 w-auto rounded-2xl bg-[#F1EFE8] p-3" data-testid="footer-logo" />
            <p className="mt-5 max-w-sm font-display text-2xl font-bold leading-tight">Consulting + SaaS for EPR, waste and circular economy.</p>
            <p className="mt-4 text-sm leading-relaxed text-emerald-100/55">Expert advice, connected systems and practical follow-through for organisations that make, use or manage materials.</p>
          </div>
          <FooterColumn title="Practices" items={PRACTICES.map((p) => [p.title, `/practice/${p.slug}`])} />
          <FooterColumn title="Platform" items={platformLinks} />
          <FooterColumn title="Insights" items={insightLinks} />
          <div>
            <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-300">Credibility</h3>
            <div className="mt-5 space-y-3 text-sm text-emerald-100/70">
              <p data-testid="footer-credibility-alumni">{CREDIBILITY[0]}</p>
              <p data-testid="footer-credibility-veterans">{CREDIBILITY[1]}</p>
              <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-emerald-300/85" data-testid="footer-credibility-networks">{CREDIBILITY[2]}</p>
            </div>
            <div className="mt-6 space-y-2 text-sm">
              <a href="mailto:alik@clymaco.com" className="block text-emerald-100/70 hover:text-emerald-300">alik@clymaco.com</a>
              <a href="tel:+918240968144" className="block text-emerald-100/70 hover:text-emerald-300">+91 8240968144</a>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-emerald-100/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 CLYMACO Sustainability Services LLP. All rights reserved.</p>
          <p>Consulting + SaaS · Illustrative product data and generated brand imagery</p>
        </div>
      </div>
    </footer>
  );
}
